// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var ReactCsv = require("react-csv");
var Js_promise = require("rescript/lib/js/js_promise.js");
var Pervasives = require("rescript/lib/js/pervasives.js");
var FileSaver = require("file-saver");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var DomToImage = require("dom-to-image");
var JsxRuntime = require("react/jsx-runtime");
var Webapi__Dom__Document = require("rescript-webapi/src/Webapi/Dom/Webapi__Dom__Document.res.js");
var Http$ReactHooksTemplate = require("../../common/http.res.js");
var Chart$ReactHooksTemplate = require("./chart.res.js");
var Image$ReactHooksTemplate = require("../../common/image.res.js");
var Utils$ReactHooksTemplate = require("../../common/utils.res.js");
var ChartId$ReactHooksTemplate = require("./chartId.res.js");
var Loading$ReactHooksTemplate = require("./Loading.res.js");
var MapAttribute$ReactHooksTemplate = require("./mapAttribute.res.js");
var MapComponent$ReactHooksTemplate = require("./MapComponent.res.js");
var TableAttribute$ReactHooksTemplate = require("./tableAttribute.res.js");
var TableComponent$ReactHooksTemplate = require("./TableComponent.res.js");
var BarChartComponent$ReactHooksTemplate = require("./BarChartComponent.res.js");
var MultipleSelectBox$ReactHooksTemplate = require("../../common/MultipleSelectBox.res.js");
var PieChartComponent$ReactHooksTemplate = require("./PieChartComponent.res.js");
var AreaChartComponent$ReactHooksTemplate = require("./AreaChartComponent.res.js");
var LineChartComponent$ReactHooksTemplate = require("./LineChartComponent.res.js");
var ScoreCardComponent$ReactHooksTemplate = require("./ScoreCardComponent.res.js");
var WordcloudComponent$ReactHooksTemplate = require("./WordcloudComponent.res.js");
var GenericChartAttribute$ReactHooksTemplate = require("./genericChartAttribute.res.js");
var ComposedChartComponent$ReactHooksTemplate = require("./ComposedChartComponent.res.js");
var RadialBarChartComponent$ReactHooksTemplate = require("./RadialBarChartComponent.res.js");

var initialState = {
  loading: true,
  chart: undefined,
  settingsDropDown: false,
  widgetSettings: false,
  downloadMenu: false,
  containerWidth: 0
};

function reducer(state, x) {
  if (typeof x !== "object") {
    return {
            loading: true,
            chart: state.chart,
            settingsDropDown: state.settingsDropDown,
            widgetSettings: state.widgetSettings,
            downloadMenu: state.downloadMenu,
            containerWidth: state.containerWidth
          };
  }
  switch (x.TAG) {
    case "FetchChartCompleted" :
        return {
                loading: false,
                chart: x._0,
                settingsDropDown: state.settingsDropDown,
                widgetSettings: state.widgetSettings,
                downloadMenu: state.downloadMenu,
                containerWidth: state.containerWidth
              };
    case "SetSettingsDropDown" :
        return {
                loading: state.loading,
                chart: state.chart,
                settingsDropDown: x._0,
                widgetSettings: state.widgetSettings,
                downloadMenu: state.downloadMenu,
                containerWidth: state.containerWidth
              };
    case "SetWidgetSettings" :
        var toggle = x._0;
        var bodyElement = Belt_Option.getExn(Webapi__Dom__Document.asHtmlDocument(document)).body;
        var $$class = Belt_Option.getExn((bodyElement == null) ? undefined : Caml_option.some(bodyElement)).classList;
        if (toggle) {
          $$class.add("overflow-hidden");
        } else {
          $$class.remove("overflow-hidden");
        }
        return {
                loading: state.loading,
                chart: state.chart,
                settingsDropDown: state.settingsDropDown,
                widgetSettings: toggle,
                downloadMenu: state.downloadMenu,
                containerWidth: state.containerWidth
              };
    case "SetDownloadMenu" :
        return {
                loading: state.loading,
                chart: state.chart,
                settingsDropDown: state.settingsDropDown,
                widgetSettings: state.widgetSettings,
                downloadMenu: x._0,
                containerWidth: state.containerWidth
              };
    case "SetContainerWidth" :
        return {
                loading: state.loading,
                chart: state.chart,
                settingsDropDown: state.settingsDropDown,
                widgetSettings: state.widgetSettings,
                downloadMenu: state.downloadMenu,
                containerWidth: x._0
              };
    
  }
}

function ChartComponent(props) {
  var __forPdf = props.forPdf;
  var __campaign = props.campaign;
  var __insight = props.insight;
  var __enlarged = props.enlarged;
  var __scoreCard = props.scoreCard;
  var onEnlarge = props.onEnlarge;
  var onClick = props.onClick;
  var drillDownChartDetails = props.drillDownChartDetails;
  var chartId = props.chartId;
  var scoreCard = __scoreCard !== undefined ? __scoreCard : false;
  var enlarged = __enlarged !== undefined ? __enlarged : false;
  var insight = __insight !== undefined ? __insight : false;
  var campaign = __campaign !== undefined ? __campaign : false;
  var forPdf = __forPdf !== undefined ? __forPdf : false;
  var match = React.useReducer(reducer, initialState);
  var dispatch = match[1];
  var state = match[0];
  var drillDownKey = drillDownChartDetails !== undefined && drillDownChartDetails[0] === ChartId$ReactHooksTemplate.id(chartId) ? drillDownChartDetails[1] : undefined;
  var handleResize = function (_event) {
    var width = window.innerWidth;
    Curry._1(dispatch, {
          TAG: "SetContainerWidth",
          _0: width
        });
  };
  var fetchVisualization = function (retryCountOpt, param) {
    var retryCount = retryCountOpt !== undefined ? retryCountOpt : 0;
    Curry._1(dispatch, "FetchChartInProgress");
    var url = insight ? "/api/v1/insights/show_visualization?visualization=" + ChartId$ReactHooksTemplate.name(chartId) : (
        campaign ? "/api/v1/campaigns/visualization_data?question_id=" + (String(ChartId$ReactHooksTemplate.id(chartId)) + ("&campaign_id=" + (String(ChartId$ReactHooksTemplate.dashboardId(chartId)) + ("&name=" + ChartId$ReactHooksTemplate.name(chartId))))) : "/api/v1/dashboards/" + (String(ChartId$ReactHooksTemplate.dashboardId(chartId)) + ("/visualizations/" + String(ChartId$ReactHooksTemplate.id(chartId))))
      );
    return Js_promise.$$catch((function (err) {
                  console.log(err);
                  if (forPdf && retryCount > 0) {
                    return Promise.resolve((setTimeout((function (param) {
                                        fetchVisualization(retryCount - 1 | 0, undefined);
                                      }), 800), undefined));
                  } else {
                    return Promise.resolve(Curry._1(dispatch, {
                                    TAG: "FetchChartCompleted",
                                    _0: undefined
                                  }));
                  }
                }), Js_promise.then_((function (xs) {
                      return Promise.resolve((setTimeout((function (param) {
                                          Curry._1(dispatch, {
                                                TAG: "FetchChartCompleted",
                                                _0: Caml_option.some(xs)
                                              });
                                        }), Utils$ReactHooksTemplate.timeout), undefined));
                    }), Http$ReactHooksTemplate.fetchGetJSONDecode(url, Chart$ReactHooksTemplate.fromJson)));
  };
  React.useEffect((function (param) {
          if (drillDownChartDetails !== undefined) {
            if (drillDownChartDetails[0] === ChartId$ReactHooksTemplate.id(chartId)) {
              
            } else {
              fetchVisualization(forPdf ? 2 : 0, undefined);
            }
          } else {
            fetchVisualization(forPdf ? 2 : 0, undefined);
          }
          handleResize(undefined);
          var listener = function (_event) {
            handleResize(Caml_option.some(_event));
          };
          window.addEventListener("resize", listener);
          return (function (param) {
                    window.removeEventListener("resize", listener);
                  });
        }), [drillDownChartDetails]);
  var chartElement = React.useRef(null);
  var saveChart = function (chart) {
    var params = {};
    params["visualization"] = Chart$ReactHooksTemplate.toJson(chart);
    var url = "/api/v1/dashboards/" + (String(ChartId$ReactHooksTemplate.dashboardId(chartId)) + ("/visualizations/" + String(ChartId$ReactHooksTemplate.id(chartId))));
    return Js_promise.then_((function (response) {
                  var status = Json_decode.field("status", (function (param) {
                          return Json_decode.withDefault("failed", Json_decode.string, param);
                        }), response);
                  if (status === "success") {
                    console.log(status);
                    Curry._1(dispatch, {
                          TAG: "FetchChartCompleted",
                          _0: Caml_option.some(Chart$ReactHooksTemplate.fromJson(response))
                        });
                  } else {
                    Curry._1(dispatch, {
                          TAG: "FetchChartCompleted",
                          _0: undefined
                        });
                  }
                  return Promise.resolve();
                }), Http$ReactHooksTemplate.fetchPostJSON(url + "/update", params));
  };
  var handleChartTypeChange = function (chartType) {
    var chart;
    switch (chartType) {
      case "Area Chart" :
          var x = state.chart;
          if (x !== undefined) {
            var x$1 = Caml_option.valFromOption(x);
            var match = Chart$ReactHooksTemplate.type_(x$1);
            var exit = 0;
            if (typeof match !== "object") {
              chart = x$1;
            } else {
              switch (match.TAG) {
                case "LineChart" :
                case "AreaChart" :
                case "PieChart" :
                case "BarChart" :
                    exit = 1;
                    break;
                default:
                  chart = x$1;
              }
            }
            if (exit === 1) {
              chart = Chart$ReactHooksTemplate.setType(x$1, {
                    TAG: "AreaChart",
                    _0: match._0
                  });
            }
            
          } else {
            chart = Pervasives.failwith("No Chart");
          }
          break;
      case "Bar Graph" :
          var x$2 = state.chart;
          if (x$2 !== undefined) {
            var x$3 = Caml_option.valFromOption(x$2);
            var match$1 = Chart$ReactHooksTemplate.type_(x$3);
            var exit$1 = 0;
            if (typeof match$1 !== "object") {
              chart = x$3;
            } else {
              switch (match$1.TAG) {
                case "LineChart" :
                case "AreaChart" :
                case "PieChart" :
                case "BarChart" :
                    exit$1 = 1;
                    break;
                default:
                  chart = x$3;
              }
            }
            if (exit$1 === 1) {
              chart = Chart$ReactHooksTemplate.setType(x$3, {
                    TAG: "BarChart",
                    _0: match$1._0
                  });
            }
            
          } else {
            chart = Pervasives.failwith("No Chart");
          }
          break;
      case "Line Graph" :
          var x$4 = state.chart;
          if (x$4 !== undefined) {
            var x$5 = Caml_option.valFromOption(x$4);
            var match$2 = Chart$ReactHooksTemplate.type_(x$5);
            var exit$2 = 0;
            if (typeof match$2 !== "object") {
              chart = x$5;
            } else {
              switch (match$2.TAG) {
                case "LineChart" :
                case "AreaChart" :
                case "PieChart" :
                case "BarChart" :
                    exit$2 = 1;
                    break;
                default:
                  chart = x$5;
              }
            }
            if (exit$2 === 1) {
              chart = Chart$ReactHooksTemplate.setType(x$5, {
                    TAG: "LineChart",
                    _0: match$2._0
                  });
            }
            
          } else {
            chart = Pervasives.failwith("No Chart");
          }
          break;
      case "Pie Chart" :
          var x$6 = state.chart;
          if (x$6 !== undefined) {
            var x$7 = Caml_option.valFromOption(x$6);
            var match$3 = Chart$ReactHooksTemplate.type_(x$7);
            var exit$3 = 0;
            if (typeof match$3 !== "object") {
              chart = x$7;
            } else {
              switch (match$3.TAG) {
                case "LineChart" :
                case "AreaChart" :
                case "PieChart" :
                case "BarChart" :
                    exit$3 = 1;
                    break;
                default:
                  chart = x$7;
              }
            }
            if (exit$3 === 1) {
              chart = Chart$ReactHooksTemplate.setType(x$7, {
                    TAG: "PieChart",
                    _0: match$3._0
                  });
            }
            
          } else {
            chart = Pervasives.failwith("No Chart");
          }
          break;
      default:
        chart = Pervasives.failwith("No Chart");
    }
    Curry._1(dispatch, {
          TAG: "FetchChartCompleted",
          _0: Caml_option.some(chart)
        });
  };
  var handleChartNameChange = function ($$event) {
    var chartName = Utils$ReactHooksTemplate.formTargetValue($$event);
    if (!Utils$ReactHooksTemplate.checkMaxLength(60, chartName)) {
      return ;
    }
    var x = state.chart;
    var chart = x !== undefined ? Chart$ReactHooksTemplate.setTitle(Caml_option.valFromOption(x), chartName) : Pervasives.failwith("No Chart");
    Curry._1(dispatch, {
          TAG: "FetchChartCompleted",
          _0: Caml_option.some(chart)
        });
  };
  var loadChart = function (chart) {
    var chartWidth;
    if (enlarged) {
      chartWidth = "w-full";
    } else {
      var mapAttribute = Chart$ReactHooksTemplate.type_(chart);
      if (typeof mapAttribute !== "object") {
        chartWidth = "w-1/2";
      } else {
        switch (mapAttribute.TAG) {
          case "ScoreCard" :
              chartWidth = "w-1/2";
              break;
          case "Map" :
              var w = MapAttribute$ReactHooksTemplate.width(mapAttribute._0);
              chartWidth = w !== undefined ? w : "w-1/2";
              break;
          case "Table" :
              var w$1 = TableAttribute$ReactHooksTemplate.width(mapAttribute._0);
              chartWidth = w$1 !== undefined ? w$1 : "w-1/2";
              break;
          default:
            var w$2 = GenericChartAttribute$ReactHooksTemplate.width(mapAttribute._0);
            chartWidth = w$2 !== undefined ? w$2 : "w-1/2";
        }
      }
    }
    var chartHeight;
    if (enlarged) {
      var match = Chart$ReactHooksTemplate.type_(chart);
      if (typeof match !== "object") {
        chartHeight = "h-96";
      } else {
        switch (match.TAG) {
          case "Map" :
          case "Table" :
              chartHeight = "h-full";
              break;
          default:
            chartHeight = "h-96";
        }
      }
    } else {
      var mapAttribute$1 = Chart$ReactHooksTemplate.type_(chart);
      if (typeof mapAttribute$1 !== "object") {
        chartHeight = "h-64";
      } else {
        switch (mapAttribute$1.TAG) {
          case "ScoreCard" :
              chartHeight = "h-64";
              break;
          case "Map" :
              var h = MapAttribute$ReactHooksTemplate.height(mapAttribute$1._0);
              chartHeight = h !== undefined ? h : "h-64";
              break;
          case "Table" :
              var h$1 = TableAttribute$ReactHooksTemplate.height(mapAttribute$1._0);
              chartHeight = h$1 !== undefined ? h$1 : "h-64";
              break;
          default:
            var w$3 = GenericChartAttribute$ReactHooksTemplate.height(mapAttribute$1._0);
            chartHeight = w$3 !== undefined ? w$3 : "h-64";
        }
      }
    }
    var zIndex = state.widgetSettings || state.settingsDropDown ? "z-10" : "";
    var chartAttribute = Chart$ReactHooksTemplate.type_(chart);
    var tmp;
    if (typeof chartAttribute !== "object") {
      tmp = JsxRuntime.jsx(JsxRuntime.Fragment, {});
    } else {
      switch (chartAttribute.TAG) {
        case "LineChart" :
            tmp = JsxRuntime.jsx(LineChartComponent$ReactHooksTemplate.make, {
                  chartAttribute: chartAttribute._0,
                  onClick: onClick,
                  enlarged: enlarged,
                  chartHeight: chartHeight,
                  containerWidth: state.containerWidth
                });
            break;
        case "AreaChart" :
            tmp = JsxRuntime.jsx(AreaChartComponent$ReactHooksTemplate.make, {
                  chartAttribute: chartAttribute._0,
                  onClick: onClick,
                  enlarged: enlarged,
                  chartHeight: chartHeight,
                  containerWidth: state.containerWidth
                });
            break;
        case "PieChart" :
            tmp = JsxRuntime.jsx(PieChartComponent$ReactHooksTemplate.make, {
                  chartAttribute: chartAttribute._0,
                  onClick: onClick,
                  chartHeight: chartHeight
                });
            break;
        case "BarChart" :
            tmp = JsxRuntime.jsx(BarChartComponent$ReactHooksTemplate.make, {
                  chartId: Chart$ReactHooksTemplate.id(chart),
                  chartAttribute: chartAttribute._0,
                  drillDownKey: drillDownKey,
                  onClick: onClick,
                  enlarged: enlarged,
                  chartHeight: chartHeight,
                  containerWidth: state.containerWidth,
                  forPdf: forPdf
                });
            break;
        case "RadialBarChart" :
            tmp = JsxRuntime.jsx(RadialBarChartComponent$ReactHooksTemplate.make, {
                  chartHeight: chartHeight
                });
            break;
        case "Wordcloud" :
            tmp = JsxRuntime.jsx(WordcloudComponent$ReactHooksTemplate.make, {
                  chartId: Chart$ReactHooksTemplate.id(chart),
                  chartAttribute: chartAttribute._0
                });
            break;
        case "ComposedChart" :
            tmp = JsxRuntime.jsx(ComposedChartComponent$ReactHooksTemplate.make, {
                  chartId: Chart$ReactHooksTemplate.id(chart),
                  chartAttribute: chartAttribute._0,
                  drillDownKey: drillDownKey,
                  onClick: onClick,
                  enlarged: enlarged,
                  chartHeight: chartHeight,
                  containerWidth: state.containerWidth
                });
            break;
        case "ScoreCard" :
            tmp = JsxRuntime.jsx(JsxRuntime.Fragment, {});
            break;
        case "Map" :
            tmp = JsxRuntime.jsx(MapComponent$ReactHooksTemplate.make, {
                  mapAttribute: chartAttribute._0,
                  enlarged: enlarged,
                  chartHeight: chartHeight
                });
            break;
        case "Table" :
            tmp = JsxRuntime.jsx(TableComponent$ReactHooksTemplate.make, {
                  attribute: chartAttribute._0,
                  chartHeight: chartHeight,
                  chartId: chartId
                });
            break;
        
      }
    }
    var tmp$1;
    if (forPdf) {
      tmp$1 = JsxRuntime.jsx(JsxRuntime.Fragment, {});
    } else {
      var mapAttribute$2 = Chart$ReactHooksTemplate.type_(chart);
      var tmp$2;
      if (typeof mapAttribute$2 !== "object") {
        tmp$2 = JsxRuntime.jsx(JsxRuntime.Fragment, {});
      } else {
        switch (mapAttribute$2.TAG) {
          case "ScoreCard" :
              tmp$2 = JsxRuntime.jsx(JsxRuntime.Fragment, {});
              break;
          case "Map" :
              tmp$2 = JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsx("div", {
                          children: JsxRuntime.jsxs(ReactCsv.CSVLink, {
                                data: MapAttribute$ReactHooksTemplate.data(mapAttribute$2._0),
                                separator: ",",
                                filename: Chart$ReactHooksTemplate.title(chart) + ".csv",
                                children: [
                                  JsxRuntime.jsx("img", {
                                        className: "w-5",
                                        src: Image$ReactHooksTemplate.csvDownloadButton
                                      }),
                                  JsxRuntime.jsx("a", {
                                        children: "Download as CSV",
                                        className: "pt-2-px"
                                      })
                                ]
                              }),
                          className: " flex text-xs gap-2"
                        }),
                    className: "w-full rounded hover:bg-palatinateblue hover:text-white p-2 sidebar"
                  });
              break;
          case "Table" :
              tmp$2 = JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsx("div", {
                          children: JsxRuntime.jsxs(ReactCsv.CSVLink, {
                                data: TableAttribute$ReactHooksTemplate.data(mapAttribute$2._0),
                                separator: ",",
                                filename: Chart$ReactHooksTemplate.title(chart) + ".csv",
                                children: [
                                  JsxRuntime.jsx("img", {
                                        className: "w-5",
                                        src: Image$ReactHooksTemplate.csvDownloadButton
                                      }),
                                  JsxRuntime.jsx("a", {
                                        children: "Download as CSV",
                                        className: "pt-2-px"
                                      })
                                ]
                              }),
                          className: " flex text-xs gap-2"
                        }),
                    className: "w-full rounded hover:bg-palatinateblue hover:text-white p-2 sidebar"
                  });
              break;
          default:
            tmp$2 = JsxRuntime.jsx("div", {
                  children: JsxRuntime.jsx("div", {
                        children: JsxRuntime.jsx(ReactCsv.CSVLink, {
                              data: GenericChartAttribute$ReactHooksTemplate.data(mapAttribute$2._0),
                              separator: ",",
                              filename: Chart$ReactHooksTemplate.title(chart) + ".csv",
                              children: JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsx("img", {
                                            className: "w-5",
                                            src: Image$ReactHooksTemplate.csvDownloadButton
                                          }),
                                      JsxRuntime.jsx("a", {
                                            children: "Download as CSV",
                                            className: "pt-2-px"
                                          })
                                    ],
                                    className: "flex text-xs items-center gap-2"
                                  })
                            }),
                        className: "flex items-center"
                      }),
                  className: "w-full rounded hover:bg-palatinateblue hover:text-white p-2 sidebar"
                });
        }
      }
      tmp$1 = JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsx("img", {
                          className: "h-18-px cursor-pointer",
                          src: Image$ReactHooksTemplate.verticalDots
                        }),
                    className: state.settingsDropDown ? "rounded-md bg-lavenderweb p-2 cursor-pointer" : "",
                    onClick: (function (param) {
                        Curry._1(dispatch, {
                              TAG: "SetSettingsDropDown",
                              _0: !state.settingsDropDown
                            });
                        Curry._1(dispatch, {
                              TAG: "SetDownloadMenu",
                              _0: false
                            });
                      })
                  }),
              JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsxs("div", {
                          children: [
                            JsxRuntime.jsx("div", {
                                  children: JsxRuntime.jsxs("a", {
                                        children: [
                                          JsxRuntime.jsx("img", {
                                                src: Image$ReactHooksTemplate.settings
                                              }),
                                          "Settings"
                                        ],
                                        className: "flex text-xs gap-2 p-2",
                                        onClick: (function (param) {
                                            Curry._1(dispatch, {
                                                  TAG: "SetSettingsDropDown",
                                                  _0: false
                                                });
                                            Curry._1(dispatch, {
                                                  TAG: "SetWidgetSettings",
                                                  _0: !state.widgetSettings
                                                });
                                          })
                                      }),
                                  className: "w-full hover:bg-palatinateblue hover:text-white sidebar "
                                }),
                            JsxRuntime.jsxs("div", {
                                  children: [
                                    JsxRuntime.jsxs("a", {
                                          children: [
                                            JsxRuntime.jsx("img", {
                                                  className: "h-16-px",
                                                  src: Image$ReactHooksTemplate.download
                                                }),
                                            "Download",
                                            JsxRuntime.jsx("img", {
                                                  className: "pl-4",
                                                  src: Image$ReactHooksTemplate.vectorRight
                                                })
                                          ],
                                          className: "flex text-xs gap-2 p-2 hover:bg-palatinateblue hover:text-white sidebar",
                                          onClick: (function (param) {
                                              Curry._1(dispatch, {
                                                    TAG: "SetDownloadMenu",
                                                    _0: !state.downloadMenu
                                                  });
                                            })
                                        }),
                                    JsxRuntime.jsxs("div", {
                                          children: [
                                            JsxRuntime.jsx("div", {
                                                  children: JsxRuntime.jsxs("a", {
                                                        children: [
                                                          JsxRuntime.jsx("img", {
                                                                className: "w-5",
                                                                src: Image$ReactHooksTemplate.pngDownloadButton
                                                              }),
                                                          JsxRuntime.jsx("a", {
                                                                children: "Download as PNG",
                                                                className: "pt-2-px"
                                                              })
                                                        ],
                                                        className: "flex text-xs gap-2",
                                                        onClick: (function (e) {
                                                            e.preventDefault();
                                                            Curry._1(dispatch, {
                                                                  TAG: "SetSettingsDropDown",
                                                                  _0: false
                                                                });
                                                            Curry._1(dispatch, {
                                                                  TAG: "SetDownloadMenu",
                                                                  _0: false
                                                                });
                                                            var ref_ = Belt_Option.getExn(Caml_option.nullable_to_opt(chartElement.current));
                                                            Js_promise.then_((function (response) {
                                                                    return Promise.resolve((FileSaver.saveAs(response, "chart.png"), undefined));
                                                                  }), DomToImage.toBlob(ref_));
                                                          })
                                                      }),
                                                  className: "w-full hover:bg-palatinateblue hover:text-white p-2 sidebar"
                                                }),
                                            tmp$2
                                          ],
                                          className: "absolute shadow-inner -mt-8 ml-130-px w-40 z-50 rounded border border-gray-400 bg-white\n                              text-darkcharcoal text-xs z-50 gap-2 py-2 cursor-pointer " + (
                                            state.downloadMenu === true ? "block" : "hidden"
                                          ),
                                          style: {
                                            transform: "translateX(-181%)"
                                          }
                                        })
                                  ],
                                  className: "w-full rounded "
                                })
                          ],
                          className: "absolute shadow-inner rounded border border-gray-400 bg-white\n                            text-darkcharcoal rounded text-xs z-50 w-131-px py-2 gap-2 cursor-pointer " + (
                            state.settingsDropDown === true ? "block" : "hidden"
                          ),
                          style: {
                            transform: "translateX(-70%)"
                          }
                        }),
                    className: "p-2"
                  })
            ],
            className: "absolute top-0 right-0 " + (
              state.settingsDropDown ? "p-2" : "p-4"
            )
          });
    }
    return JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsxs("div", {
                                children: [
                                  JsxRuntime.jsxs("h4", {
                                        children: [
                                          forPdf ? JsxRuntime.jsx(JsxRuntime.Fragment, {}) : JsxRuntime.jsx("img", {
                                                  alt: "doubleMinimize",
                                                  src: Image$ReactHooksTemplate.doubleMinimize
                                                }),
                                          Chart$ReactHooksTemplate.title(chart)
                                        ],
                                        className: "animated fadeIn font-bold text-charcoal p-20-px flex"
                                      }),
                                  JsxRuntime.jsx("div", {
                                        children: tmp,
                                        className: "w-full animated fadeIn"
                                      }),
                                  tmp$1
                                ],
                                ref: Caml_option.some(chartElement),
                                className: "border border-gray-400 rounded bg-white"
                              }),
                          enlarged ? JsxRuntime.jsx(JsxRuntime.Fragment, {}) : JsxRuntime.jsx("div", {
                                  children: JsxRuntime.jsx("button", {
                                        children: JsxRuntime.jsx("img", {
                                              className: "w-5",
                                              alt: "Expand",
                                              src: Image$ReactHooksTemplate.expand
                                            }),
                                        onClick: (function (e) {
                                            e.preventDefault();
                                            Curry._1(onEnlarge, undefined);
                                          })
                                      }),
                                  className: "absolute top-0 right-32-px p-16-px"
                                })
                        ],
                        className: "relative"
                      }),
                  JsxRuntime.jsx("div", {
                        children: JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx("div", {
                                      children: JsxRuntime.jsxs("div", {
                                            children: [
                                              JsxRuntime.jsx("div", {
                                                    children: "Widget Settings"
                                                  }),
                                              JsxRuntime.jsx("img", {
                                                    className: "h-14-px float-right cursor-pointer",
                                                    src: Image$ReactHooksTemplate.closeIcon,
                                                    onClick: (function (param) {
                                                        Curry._1(dispatch, {
                                                              TAG: "SetSettingsDropDown",
                                                              _0: true
                                                            });
                                                        Curry._1(dispatch, {
                                                              TAG: "SetWidgetSettings",
                                                              _0: !state.widgetSettings
                                                            });
                                                        Curry._1(dispatch, {
                                                              TAG: "SetSettingsDropDown",
                                                              _0: false
                                                            });
                                                      })
                                                  })
                                            ],
                                            className: "p-8 text-xl font-semibold flex justify-between"
                                          }),
                                      className: "border-b border-lavenderweb border-x-8"
                                    }),
                                JsxRuntime.jsxs("div", {
                                      children: [
                                        JsxRuntime.jsx("div", {
                                              children: JsxRuntime.jsx("div", {
                                                    children: JsxRuntime.jsx("a", {
                                                          children: "Appearance",
                                                          className: "text-base font-semibold"
                                                        }),
                                                    className: "border-b border-lavenderweb py-3 pl-8"
                                                  }),
                                              className: "w-4/12 border-r border-lavenderweb border-x-8"
                                            }),
                                        JsxRuntime.jsxs("div", {
                                              children: [
                                                JsxRuntime.jsxs("div", {
                                                      children: [
                                                        JsxRuntime.jsx("div", {
                                                              children: "Representation",
                                                              className: "text-md font-normal"
                                                            }),
                                                        JsxRuntime.jsx("div", {
                                                              children: JsxRuntime.jsx(MultipleSelectBox$ReactHooksTemplate.make, {
                                                                    options: Chart$ReactHooksTemplate.compatibleCharts(chart),
                                                                    placeholder: Chart$ReactHooksTemplate.chartTypeToString(chart),
                                                                    handleChange: handleChartTypeChange,
                                                                    selectedOptions: /* [] */0,
                                                                    className: "border border-gray-400 rounded-md px-3 py-2",
                                                                    optionsHoverColor: "hover:bg-pigmentblue hover:text-white",
                                                                    listBoxCss: "py-2 "
                                                                  }),
                                                              className: "w-3/5"
                                                            })
                                                      ],
                                                      className: "flex items-center justify-between py-2 w-full h-32-px"
                                                    }),
                                                JsxRuntime.jsxs("div", {
                                                      children: [
                                                        JsxRuntime.jsx("div", {
                                                              children: "Name",
                                                              className: "text-md font-normal"
                                                            }),
                                                        JsxRuntime.jsx("input", {
                                                              className: "border border-gray-400 rounded-md pl-2 w-3/5 h-32-px",
                                                              id: "chart_name",
                                                              type: "text",
                                                              value: Chart$ReactHooksTemplate.title(chart),
                                                              onChange: handleChartNameChange
                                                            })
                                                      ],
                                                      className: "flex items-center justify-between pt-10 py-2 w-full h-32-px"
                                                    }),
                                                Chart$ReactHooksTemplate.title(chart).length === 0 ? JsxRuntime.jsx("p", {
                                                        children: "Name can't be empty",
                                                        className: "text-red-500 text-xs pt-2 float-right"
                                                      }) : JsxRuntime.jsx("p", {
                                                        children: String(Chart$ReactHooksTemplate.title(chart).length) + (" / " + String(60)),
                                                        className: "text-gray-500 text-xs pt-2 float-right"
                                                      })
                                              ],
                                              className: "w-full pt-6 px-6"
                                            })
                                      ],
                                      className: "flex-grow flex"
                                    }),
                                JsxRuntime.jsxs("div", {
                                      children: [
                                        JsxRuntime.jsx("button", {
                                              children: "Cancel",
                                              className: "border border-gray-400 flex rounded py-3 px-6 text-base font-semibold justify-center",
                                              id: "close_modal",
                                              onClick: (function (param) {
                                                  Curry._1(dispatch, {
                                                        TAG: "SetWidgetSettings",
                                                        _0: !state.widgetSettings
                                                      });
                                                  Curry._1(dispatch, {
                                                        TAG: "SetSettingsDropDown",
                                                        _0: false
                                                      });
                                                  fetchVisualization(forPdf ? 2 : 0, undefined);
                                                })
                                            }),
                                        JsxRuntime.jsx("button", {
                                              children: "Save",
                                              className: "bg-palatinateblue border border-gray-400 flex rounded\n                         py-3 px-6 text-base font-semibold text-white justify-center " + (
                                                Chart$ReactHooksTemplate.title(chart).length === 0 ? "disabled-input" : ""
                                              ),
                                              disabled: Chart$ReactHooksTemplate.title(chart).length === 0,
                                              onClick: (function (param) {
                                                  Curry._1(dispatch, {
                                                        TAG: "SetWidgetSettings",
                                                        _0: !state.widgetSettings
                                                      });
                                                  Curry._1(dispatch, {
                                                        TAG: "SetSettingsDropDown",
                                                        _0: false
                                                      });
                                                  saveChart(chart);
                                                })
                                            })
                                      ],
                                      className: "py-5 pr-8 flex border-t border-gray-200 gap-3 font-medium text-base w-full justify-end"
                                    })
                              ],
                              className: "bg-white relative border border-gray-300 rounded-lg w-3/5 h-5/9 flex flex-col"
                            }),
                        className: "w-screen z-50 disabled-wrapper absolute inset-0 flex justify-center items-center " + (
                          state.widgetSettings === true ? "block" : "hidden"
                        ),
                        style: {
                          height: "calc(100vh + 5rem)",
                          overflow: "hidden",
                          position: "fixed"
                        }
                      })
                ],
                className: chartWidth + " " + zIndex + " pb-16-px pr-16-px rounded-sm animated fadeIn"
              });
  };
  var tmp;
  if (state.loading) {
    tmp = JsxRuntime.jsx(Loading$ReactHooksTemplate.make, {});
  } else {
    var chart = state.chart;
    if (chart !== undefined) {
      var chart$1 = Caml_option.valFromOption(chart);
      var chartAttribute = Chart$ReactHooksTemplate.type_(chart$1);
      tmp = typeof chartAttribute !== "object" || chartAttribute.TAG !== "ScoreCard" ? JsxRuntime.jsx(JsxRuntime.Fragment, {}) : JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx(ScoreCardComponent$ReactHooksTemplate.make, {
                    chartId: Chart$ReactHooksTemplate.id(chart$1),
                    chartAttribute: chartAttribute._0,
                    onClick: onClick
                  }),
              className: "w-full"
            });
    } else {
      tmp = "No Data Loaded for the chart";
    }
  }
  var loadScoreCard = JsxRuntime.jsx("div", {
        children: tmp,
        className: "min-w-265-px"
      });
  var loadOtherCharts;
  if (state.loading) {
    loadOtherCharts = JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx(Loading$ReactHooksTemplate.make, {
                img: Caml_option.some(Image$ReactHooksTemplate.dashboardLoading),
                text: "Loading chart"
              }),
          className: "w-1/2 pb-16-px pr-16-px rounded-sm animated fadeIn " + (
            state.settingsDropDown ? "z-50" : ""
          )
        });
  } else {
    var chart$2 = state.chart;
    loadOtherCharts = chart$2 !== undefined ? loadChart(Caml_option.valFromOption(chart$2)) : "No Data Loaded for the chart";
  }
  if (scoreCard) {
    return loadScoreCard;
  } else {
    return loadOtherCharts;
  }
}

var make = ChartComponent;

exports.initialState = initialState;
exports.reducer = reducer;
exports.make = make;
/* react Not a pure module */
